import React, { useState, useEffect } from 'react';
import { FaTruck, FaWhatsapp, FaClipboardList, FaMoneyBillWave, FaMapMarkerAlt, FaPhone, FaEnvelope, FaCheckCircle, FaClock } from 'react-icons/fa';
import { getUpdatedBranches } from '../utils/branchesData';
import './Delivery.css';

function Delivery() {
  const [deliveryBranches, setDeliveryBranches] = useState([]);

  useEffect(() => {
    const loadDeliveryBranches = () => {
      const branches = getUpdatedBranches();
      const deliveryBranchesData = branches.map(branch => ({
        id: branch.id,
        name: branch.city,
        status: branch.hasDelivery ? 'active' : 'coming-soon',
        statusText: branch.hasDelivery ? 'Available Now' : 'Coming Soon',
        location: `${branch.location}, ${branch.address}`,
        phone: branch.phone[0] || branch.whatsapp,
        icon: branch.hasDelivery ? <FaCheckCircle /> : <FaClock />
      }));
      setDeliveryBranches(deliveryBranchesData);
    };

    // Load initial data
    loadDeliveryBranches();

    // Listen for branch updates from admin panel
    const handleBranchUpdate = () => {
      loadDeliveryBranches();
    };

    window.addEventListener('branchesUpdated', handleBranchUpdate);
    
    return () => {
      window.removeEventListener('branchesUpdated', handleBranchUpdate);
    };
  }, []);

  return (
    <div className="delivery">
      <div className="delivery-container">
        <div className="delivery-header">
          <div className="delivery-icon">
            <FaTruck />
          </div>
          <h2>Pharmacy Delivery Service</h2>
          <p className="delivery-intro">
            Try our pharmacy delivery service today and experience the convenience of having 
            your medications delivered directly to your door from your nearest branch.
          </p>
        </div>

        {/* Delivery from Nearest Branch Section */}
        <div className="delivery-branches-section">
          <h3><FaMapMarkerAlt /> Delivery from Nearest Branch</h3>
          <p className="branches-intro">
            Select your nearest branch for faster delivery. Currently serving from Lilongwe, 
            with more locations launching soon!
          </p>
          
          <div className="branches-grid">
            {deliveryBranches.map((branch) => (
              <div 
                key={branch.id} 
                className={`delivery-branch-card ${branch.status}`}
              >
                <div className="branch-status-badge">
                  {branch.icon}
                  <span>{branch.statusText}</span>
                </div>
                <h4>{branch.name}</h4>
                <p className="branch-location">{branch.location}</p>
                {branch.status === 'active' && (
                  <a href={`tel:${branch.phone}`} className="branch-contact">
                    <FaPhone /> {branch.phone}
                  </a>
                )}
              </div>
            ))}
          </div>
        </div>

        <div className="delivery-content">
          <div className="delivery-visual">
            <div className="delivery-image-placeholder">
              <div className="delivery-badge">
                <span className="badge-icon">
                  <FaTruck />
                </span>
              </div>
            </div>
          </div>

          <div className="delivery-info">
            <div className="how-it-works">
              <h3>
                <span className="how-icon"><FaClipboardList /></span>
                How It's Done
              </h3>
              <ol className="steps-list">
                <li>
                  <span className="step-number">1</span>
                  <div className="step-content">
                    <strong><FaWhatsapp style={{marginRight: '8px'}} />Add the WhatsApp number</strong>
                    <p>Start by adding our WhatsApp contact</p>
                  </div>
                </li>
                <li>
                  <span className="step-number">2</span>
                  <div className="step-content">
                    <strong>Send a message</strong>
                    <p>Reach out to us with your inquiry</p>
                  </div>
                </li>
                <li>
                  <span className="step-number">3</span>
                  <div className="step-content">
                    <strong>Upload the prescription</strong>
                    <p>Share your prescription with us</p>
                  </div>
                </li>
                <li>
                  <span className="step-number">4</span>
                  <div className="step-content">
                    <strong><FaMoneyBillWave style={{marginRight: '8px'}} />Send payment or COD</strong>
                    <p>Pay securely or choose cash on delivery</p>
                  </div>
                </li>
                <li>
                  <span className="step-number">5</span>
                  <div className="step-content">
                    <strong><FaMapMarkerAlt style={{marginRight: '8px'}} />Send the delivery location</strong>
                    <p>Provide your delivery address</p>
                  </div>
                </li>
              </ol>
            </div>

            <div className="contact-cta">
              <h3>Call Lilongwe Branch Today</h3>
              <div className="contact-details">
                <div className="contact-item">
                  <FaPhone />
                  <span className="contact-label">Retail:</span>
                  <a href="tel:+265995165735">+265 995 165 735</a>
                </div>
                <div className="contact-item">
                  <FaPhone />
                  <span className="contact-label">Wholesale:</span>
                  <a href="tel:+265881193314">+265 881 193 314</a>
                </div>
                <div className="contact-item">
                  <FaEnvelope />
                  <span className="contact-label">Email:</span>
                  <a href="mailto:info@pharmacaremw.com">info@pharmacaremw.com</a>
                </div>
              </div>
              <a 
                href="https://wa.me/265995165735?text=Hello%20Pharmacare,%20I%20would%20like%20to%20place%20a%20delivery%20order." 
                target="_blank" 
                rel="noopener noreferrer"
                className="order-btn"
              >
                <FaWhatsapp /> ORDER NOW VIA WHATSAPP
                <span className="btn-icon"><FaTruck /></span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Delivery;
